import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";
import "./BreadcrumbItem.css"

class BreadcrumbItem extends Component {

  render() {
    const {title, to, active} = this.props;
    const isActive = active ? 'active' : ''
    return <li className={"breadcrumb-item" + isActive}>
      {to && active !== true ? <Link to={to}>
        {title}
      </Link> : title}
    </li>
  }

}

BreadcrumbItem.propTypes = {
  title: PropTypes.string,
  to: PropTypes.string,
  icon: PropTypes.string,
  active: PropTypes.any
};

export default BreadcrumbItem;




// WEBPACK FOOTER //
// ./src/component/BreadcrumbItem/BreadcrumbItem.js